import { ChangeDetectionStrategy, Component, ViewChild } from "@angular/core";
import { PersonFlag } from "@common/ADAPT.Common.Model/person/person-flag.enum";
import { GuidedTourService } from "@common/lib/guided-tour/guided-tour.service";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { DismissibleCtaComponent } from "@org-common/lib/call-to-action/dismissible-cta/dismissible-cta.component";
import { PersonFlagService } from "@org-common/lib/person/person-flag.service";
import { AiTour, EmbedShellTourButton } from "app/tours/embed-shell-tour";
import { Observable } from "rxjs";

@Component({
    selector: "adapt-ai-tour-prompt-dashboard-element",
    standalone: false,
    templateUrl: "./ai-tour-prompt-dashboard-element.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: [":host { display: contents }"],
})
export class AiTourPromptDashboardElementComponent extends BaseComponent {
    public readonly PersonFlag = PersonFlag;

    @ViewChild(DismissibleCtaComponent) public ctaComponent?: DismissibleCtaComponent;
    public shellTourCompleted$: Observable<boolean>;

    constructor(
        private guidedTourService: GuidedTourService,
        personFlagService: PersonFlagService,
    ) {
        super();

        this.shellTourCompleted$ = personFlagService.isFlagEnabled$(PersonFlag.ShellTourDismissed);
    }

    public runTour() {
        this.guidedTourService.run(AiTour);
        this.ctaComponent?.dismiss(true);
    }

    public onDismiss(triggeredByRun: boolean) {
        if (!triggeredByRun) {
            this.guidedTourService.run(EmbedShellTourButton);
        }
    }
}
